import {
    DWT_DEFRA_SUBMISSIONS_END_DATE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_FACILITY_CODE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_DEFAULT_VALUE,
    DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_SELECT_OPTIONS,
    DWT_DEFRA_SUBMISSIONS_START_DATE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_STATUS_ELEMENT_ID,
    DWT_DEFRA_SUBMISSION_STATUS_CODE_VALUES,
} from '../../../dwt-defra-submissions/dwt-defra-submissions.constants';
import { DWT_DEFRA_SUBMISSIONS_STATUS_MULTISELECT_OPTIONS } from '../../../dwt-defra-submissions/dwt-defra-submissions-status-multiselect-options';
import type {
    ReportFilterFieldSpec,
    ReportingTargetFilterDefinition,
} from '../reporting-target-filter.types';

const DWT_DEFRA_DATE_RANGE_ROW = 'dwt-defra-submissions-date-range';

const DWT_DEFRA_SUBMISSIONS_TARGET_FIELDS: readonly ReportFilterFieldSpec[] = [
    {
        elementId: DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_ELEMENT_ID,
        label: 'Record Count',
        kind: 'select',
        defaultValue: DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_DEFAULT_VALUE,
        options: DWT_DEFRA_SUBMISSIONS_RECORD_COUNT_SELECT_OPTIONS,
    },
    {
        elementId: DWT_DEFRA_SUBMISSIONS_FACILITY_CODE_ELEMENT_ID,
        label: 'Facility',
        kind: 'multiselect',
        placeholder: 'Select one or more facilities',
        options: [],
        visibleSize: 6,
    },
    {
        elementId: DWT_DEFRA_SUBMISSIONS_START_DATE_ELEMENT_ID,
        label: 'Start date',
        kind: 'date',
        optional: true,
        rowGroup: DWT_DEFRA_DATE_RANGE_ROW,
    },
    {
        elementId: DWT_DEFRA_SUBMISSIONS_END_DATE_ELEMENT_ID,
        label: 'End date',
        kind: 'date',
        optional: true,
        rowGroup: DWT_DEFRA_DATE_RANGE_ROW,
    },
    {
        elementId: DWT_DEFRA_SUBMISSIONS_STATUS_ELEMENT_ID,
        label: 'Status',
        kind: 'multiselect',
        placeholder: 'Select status',
        options: DWT_DEFRA_SUBMISSIONS_STATUS_MULTISELECT_OPTIONS,
        defaultSelectedValues: DWT_DEFRA_SUBMISSION_STATUS_CODE_VALUES,
        visibleSize: 3,
    },
];

/**
 * Reporting target: DWT - Submissions to DEFRA — must match `<option value="...">` in `taskpane.html`.
 */
export const dwtDefraSubmissionsReportingTargetDefinition: ReportingTargetFilterDefinition = {
    targetId: 'dwt-submissions-to-defra',
    displayName: 'DWT - Submissions to DEFRA',
    fetchImplemented: true,
    commonFilterFields: [],
    targetFilterFields: DWT_DEFRA_SUBMISSIONS_TARGET_FIELDS,
};
